<template>

  <div class="words-query">

    <form action="#">

      <div v-for="(category,index) in categories">
        <label>{{ translateColumn(category.columnName) }}</label>
        <MultiSelect :allOption="true" many="selected"
                     :options="category.options" :value="selectedCategories[index].options"
                     @update:value="(...args) => updateCategories(index, ...args)"></MultiSelect>
      </div>

      <label>{{ i18n().columns }}</label>

      <MultiSelect :options="columns" :value.sync="wordsColumns" :display="(c) => translateColumn(c)"></MultiSelect>

      <label for="min-words">{{ i18n().number }}</label>
      <div id="words-number">
        <div class="mdl-textfield mdl-js-textfield">
          <input class="mdl-textfield__input" type="text" pattern="-?[0-9]*(\.[0-9]+)?" id="min-words"
                 v-model="minWords">
          <label class="mdl-textfield__label" for="min-words">{{ i18n.min }}</label>
          <span class="mdl-textfield__error">{{ i18n().isNotANumber }}</span>
        </div>
        <span class="range-to">-</span>
        <div class="mdl-textfield mdl-js-textfield">
          <input class="mdl-textfield__input" type="text" pattern="-?[0-9]*(\.[0-9]+)?" id="max-words"
                 v-model="maxWords">
          <label class="mdl-textfield__label" for="max-words">{{ i18n.max }}</label>
          <span class="mdl-textfield__error">{{ i18n().isNotANumber }}</span>
        </div>
      </div>

      <div class="check-box" v-on:click="toggleSpecialCharacters">
        <span>
          <i v-if="ignoreSpecialCharacters" class="material-icons">check_box</i>
          <i v-if="!ignoreSpecialCharacters" class="material-icons">check_box_outline_blank</i>
        </span>
        <span>{{ i18n().ignoreSpecial }}</span>
      </div>

      <div class="check-box" v-on:click="toggleIgnoreCase">
        <span>
          <i v-if="ignoreCase" class="material-icons">check_box</i>
          <i v-if="!ignoreCase" class="material-icons">check_box_outline_blank</i>
        </span>
        <span>{{ i18n().ignoreCase }}</span>
      </div>

    </form>
  </div>

</template>

<script>
import wordsAnalyzer from "../../logic/wordsAnalyzer"
import MultiSelect from "../utils/MultiSelect.vue"
import i18n from "i18n"

export default {
  name: 'words-query',
  components: { MultiSelect },
  props: {
    columns: {
      type: Array
    },
    categories: {
      type: Array
    },
    query: {
      type: Object,
      default() {
        return {
          categories: 'all',
          wordsColumns: [],
          minWords: 1,
          maxWords: 2,
          ignoreSpecialCharacters: true,
          ignoreCase: true
        }
      }
    }
  },
  data () {
    //console.error("DEFAULT WC", this.query)
    return {
      wordsColumns: this.query.wordsColumns,
      minWords: this.query.minWords,
      maxWords: this.query.maxWords,
      ignoreSpecialCharacters: this.query.ignoreSpecialCharacters,
      ignoreCase: this.query.ignoreCase,
      selectedCategories: []
    }
  },
  computed: {
  },
  watch: {
    categories() {
      this.selectedCategories = JSON.parse(JSON.stringify(this.categories))
    },
    query(q) {
      this.wordsColumns = this.query.wordsColumns
      this.minWords = this.query.minWords
      this.maxWords = this.query.maxWords
      this.ignoreSpecialCharacters = this.query.ignoreSpecialCharacters
      this.ignoreCase = this.query.ignoreCase
      this.selectedCategories = (!this.query.categories || this.query.categories == 'all')
                                ? JSON.parse(JSON.stringify(this.categories))
                                : JSON.parse(JSON.stringify(this.query.categories))
    },
    wordsColumns(v) {
      console.log("WORDS COLUMNS", v)
      //if(JSON.stringify(this.query.wordsColumns) == JSON.stringify(v)) return;
      let query = JSON.parse(JSON.stringify(this.query))
      query.wordsColumns = v
      this.$emit("update:query", query)
    },
    minWords(v) {
      let query = JSON.parse(JSON.stringify(this.query))
      query.minWords = +v
      this.$emit("update:query", query)
    },
    maxWords(v) {
      let query = JSON.parse(JSON.stringify(this.query))
      query.maxWords = +v
      this.$emit("update:query", query)
    },
    ignoreSpecialCharacters(v) {
      let query = JSON.parse(JSON.stringify(this.query))
      query.ignoreSpecialCharacters = v
      this.$emit("update:query", query)
    },
    ignoreCase(v) {
      let query = JSON.parse(JSON.stringify(this.query))
      query.ignoreCase = v
      this.$emit("update:query", query)
    }
  },
  methods: {
    i18n() {
      return i18n().words.query
    },
    translateColumn(col) {
      return i18n().translateColumnName(col)
    },
    toggleSpecialCharacters() {
      this.ignoreSpecialCharacters = ! this.ignoreSpecialCharacters
    },
    toggleIgnoreCase() {
      this.ignoreCase = ! this.ignoreCase
    },
    updateCategories(index, value) {
      this.selectedCategories[index].options = value
      let query = JSON.parse(JSON.stringify(this.query))
      query.categories = JSON.parse(JSON.stringify(this.selectedCategories))
      this.$emit("update:query", query)
    }
  },
  created() {
    this.selectedCategories = JSON.parse(JSON.stringify(this.categories))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .mdl-selectfield {
    width: 12em;
    padding-top: 0.23em;
    padding-bottom: 1.0em;
  }

  h8 {
    margin: 0;
  }

  .range-to {
    display: inline-block;
    margin-right: 1em;
    top: 1px;
    vertical-align: baseline;
    position: relative;
  }

  .mdl-textfield {
    width: 3.5em;
    display: inline-block;
    margin-right: 1em;
    vertical-align: baseline;


    padding-top: 0.23em;
    padding-bottom: 1.3em;
  }
  .mdl-textfield input {
    text-align: center;
  }


  .check-box {
    cursor: default;
  }
  .check-box i {
    position: relative;
    top: 6px;
  }


  #words-number {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// WordsQuery.vue?15e08a50